import axios from "axios";
import {output_roubles} from "../../../../../modules/vegas/js/util";

class CatalogProduct {
	init(product) {
		this.deliveryRequestId = 0;
		this.updateInstallments(product);
		this.loadDeliveriesPrices(product);

		product.addEventListener('change-counter', () => {
			this.updateInstallments(product);
			this.deliveryRequestId++;
			this.showDeliveryLoading(product);
			clearTimeout(this.deliveryTimer);
			this.deliveryTimer = setTimeout(() => this.loadDeliveriesPrices(product), 200);
		});
	}

	getQuantity(product) {
		return Number(product.querySelector('[data-cart="qty"] input')?.value) || 1;
	}

	updateInstallments(product) {
		let installments = product.querySelector('.installments');
		if (!installments) return;

		let sum = Math.trunc(Number(installments.dataset.price) * this.getQuantity(product));
		installments.querySelectorAll('[data-installment]').forEach(element => {
			let enabled = sum >= Number(element.dataset.min) && sum <= Number(element.dataset.max);
			let payment = Math.round(sum / Number(element.dataset.parts));
			element.classList.toggle('disabled', !enabled);
			element.querySelector('[data-installment-payment]').innerHTML = enabled
				? (element.dataset.installment === 'dolyame'
					? `${output_roubles(payment)} х ${element.dataset.parts} части`
					: `от ${output_roubles(payment)} в месяц`)
				: `При сумме от ${output_roubles(element.dataset.min)} до ${output_roubles(element.dataset.max)}`;
		});
	}

	showDeliveryLoading(product) {
		product.querySelectorAll('.delivery-area .price b, [data-post-tariff-price]').forEach(element => {
			element.innerHTML = '<i class="fa fa-spin fa-spinner"></i>';
		});
		product.querySelectorAll('[data-post-tariff-period]').forEach(element => {
			element.textContent = '';
		});
	}

	loadDeliveriesPrices(product) {
		let deliveries = product.querySelector('.delivery-area');
		if (!deliveries) {
			return;
		}

		let params = {
			id: product.dataset.id,
			cnt: this.getQuantity(product),
			deliveries: [...deliveries.querySelectorAll('[data-delivery_id]')]
				.map(el => el.dataset.delivery_id)
		}

		if (params.deliveries.length) {
			let requestId = this.deliveryRequestId = (this.deliveryRequestId || 0) + 1;
			this.showDeliveryLoading(product);
			return axios.get('/catalog/get_delivery_prices', {
				params: params
			}).then((response) => {
				if (requestId !== this.deliveryRequestId) return;

				for (let deliveryId in response.data.deliveries) {
					let element = deliveries.querySelector(`[data-delivery_id="${deliveryId}"]`);
					if (!element) continue;
					let tariffs = response.data.deliveries[deliveryId].tariffs;

					if (tariffs && element.querySelector('[data-post-tariffs]')) {
						for (let tariffKey in tariffs) {
							let tariffElement = element.querySelector(`[data-post-tariff="${tariffKey}"]`);
							let tariff = tariffs[tariffKey];

							if (!tariffElement) continue;

							tariffElement.classList.toggle('disabled', !tariff.available);
							tariffElement.querySelector('[data-post-tariff-price]').innerHTML = tariff.available
								? output_roubles(tariff.price)
								: 'недоступен';
							tariffElement.querySelector('[data-post-tariff-period]').textContent = tariff.delivery_period_text || '';
						}

						element.dataset.loaded = '1';
						continue;
					}

					let price = response.data.deliveries[deliveryId].price;

					price = isNaN(price)
						? price
						: (price > 0 ? output_roubles(price) : 'бесплатно');

					element.querySelector('.price b').innerHTML = price;
					element.dataset.loaded = '1';
				}
			}).catch(() => {
				if (requestId !== this.deliveryRequestId) return;
				deliveries.querySelectorAll('.price b, [data-post-tariff-price]').forEach(element => {
					element.textContent = 'не удалось рассчитать';
				});
			});
		}
	}
}

export default CatalogProduct;
